export const LTS_PAGE_SEO_CONTENT = [
  {
    description: `<h2 class="contentHeading">Check Live Train Running Status on MakeMyTrip</h2>
    <div class="contentDescription">
      <p>
        Checking your <strong>live train status</strong> gets easy and quick with MakeMyTrip now as our updated interface brings a bunch of 
        useful customisations to match your query. Accessible through the MakeMyTrip official website and mobile phone-based app, 
        the <strong>live train running status</strong> interface is the one-stop destination for all your train information requirements, 
        whether boarding a train, completing a journey or even receiving a loved one.
      </p>
      <p>
      From platform details to schedule delays and remaining distance, MakeMyTrip's train tracking platform displays the <strong>IRCTC live train 
      status</strong> with close accuracy. You simply need to enter your train name or number and choose the date of the journey to track your train.
      </p>
    </div>`
  },
  {
    description: `<h2 class="contentHeading">Go Beyond Just Location With MakeMyTrip's Live Train Status Checker</h2>
    <div class="contentDescription">
      <p>
      The <strong>live train status</strong> checker from MakeMyTrip brings to you much more than just your train's location. When you enter your 
      query to <strong>check live train status</strong>, our train checker brings accurate information related to several other train details.
      </p>
      <ul class="list appendBottom10">
      <li>The total distance covered and distance remaining for the train journey help gauge the remaining journey easily.</li>
      <li>Distance between two train stations helps plan the journey better.</li>
      <li>You can also check the platform number where your train would stop at each station en route and the duration of the stop.</li>
      <li>To better <strong>track train live status</strong>, the status checker also displays the time difference between 
      scheduled arrival and actual arrival for each station.</li>
      <li>The difference between scheduled and actual departure times for each station stop en route assists with better deboarding planning.</li>
      <li>You can also check the total number of stations between two locations when tracking your <strong>live train status</strong>.</li>
    </ul>
    </div>`
  },
  {
    description: `<h2 class="contentHeading">Check Live Train Status More Accurately on MakeMyTrip</h2>
    <div class="contentDescription">
      <p>
      When you <strong>track train running status</strong> live on MakeMyTrip, you can be assured of closely accurate tracking 
      with only a small margin of delay. The <strong>live train status</strong> that MakeMyTrip provides is sourced directly from 
      NTES or National Train Enquiry System, the train tracking platform introduced by Indian Railways that IRCTC relies on for 
      accurate, GPS-based tracking of all trains.
      </p>
      <p>
      As the authorised railways ticket booking partner of IRCTC, MakeMyTrip also uses IRCTC's reliable tracking platform to 
      <strong>track train live status</strong> that both customers and one-time users can rely on to check their train's 
      location and other pertinent details.
      </p>
    </div>`
  },
  {
    description: `<h2 class="contentHeading">Ways to Track Train Live Status on MakeMyTrip</h2>
    <div class="contentDescription">
      <p>
        You can track IRCTC live train status with MakeMyTrip's train status checker in the following ways.
      </p>
      <ol class="list appendBottom10">
        <li><strong>Via the official website:</strong> Visit the official MakeMyTrip website, go to 'Train' and 
        choose the 'Live Train Status' service to enter your train details and check.</li>
        <li><strong>Through the MakeMyTrip app:</strong> Alternatively, you can download the MakeMyTrip app on your 
        phone, go to 'Train' and click on 'Live Train Status' to check the <strong>live train running status</strong> accurately.</li>
      </ol>
      <p>
        When tracking train status on either platform, you can choose from the following entry types to 
        <strong>track train running status</strong> live.
      </p>
      <p>
        - With train number</br>
        - With train name
      </p>
    </div>`
  },
  {
    description: `<h2 class="contentHeading">Things You Must Know to Track Train Running Status</h2>
    <div class="contentDescription">
      <p>
        When tracking your <strong>live train status</strong> with MakeMyTrip, some things you must know are - 
      </p>
      <ul class="list appendBottom10">
      <li>Train name or number must be right for accurate tracking.</li>
      <li>For long-distance trains with a route spanning more than one day, choosing the right journey date is crucial.</li>
      <li>You must also enter the source and destination details correctly for accurate tracking.</li>
      </ul>
    </div>`
  }
];

export const PRODUCT_FEATURES_CARD_DATA = {
  label: 'Easily check Live Train Status and book IRCTC Train Tickets on MakeMyTrip',
  listItems: [
    {
      iconName: 'railSeoSprite bluePnrStatus',
      label: 'PNR Status',
      subLabel:
        'Check your PNR status and with our Trip Guarantee feature, get a confirm IRCTC ticket of 3X refund incase ticket is not confirmed. You can also opt for real time PNR status update on WhatsApp.'
    },
    {
      iconName: 'railSeoSprite blueTripGuarantee',
      label: 'Trip Guarantee',
      subLabel:
        'Rest assured about your upcoming travel plans, even when the PNR status is waitlisted. With Trip Guarantee, get a confirmed ticket or receive a 3X refund.'
    },
    {
      iconName: 'railSeoSprite blueFreeCancellation',
      label: 'Free Cancellation',
      subLabel:
        'Keep your travel plans flexible. When you book with free cancellation, you get a full and instant refund for your ticket cost, whether the PNR status is confirmed or waitlisted.'
    },
    {
      iconName: 'railSeoSprite blueLiveTrainStatus',
      label: 'Live Train Status',
      subLabel:
        'Apart from the PNR status, you can also check the live train status on the MakeMyTrip app or website. Stay updated about route, running time, schedule, delays, and more along the way.'
    },
    {
      iconName: 'railSeoSprite blueHighestBookingSuccess',
      label: 'Highest Booking Success',
      subLabel:
        'MakeMyTrip offers seamless and instant train booking. On the app or website, you can get real-time info on the PNR status, live train status, and other important details.'
    },
    {
      iconName: 'railSeoSprite blueBookNowPayLater',
      label: 'Buy Now, Pay Later',
      subLabel: 'Make a booking by paying only Rs.0 now and pay the amount later! Offering starts at 0% interest.'
    },
    {
      iconName: 'railSeoSprite blueGreatOffers',
      label: 'Great offers & discounts',
      subLabel:
        'Book your ticket through MakeMyTrip App or website and pay 0 convenience fee on your first train ticket.'
    },
    {
      iconName: 'railSeoSprite blueAlternateRoute',
      label: 'Alternate Route Tickets',
      subLabel:
        'With our alternate route feature, increase your chances of getting confirm IRCTC train tickets and easily check and get instant updates of your PNR Status.'
    }
  ]
};

export const LTS_FAQ = {
  label: 'Frequently Asked Questions',
  listItems: [
    {
      question: '<h3>What is the source for Live Train Status for MakeMyTrip?</h3>',
      answer:
        '<p>MakeMyTrip uses data and information from Indian Railways-operated NTES as the authentic source for providing <strong>live train status to users</strong>.</p>'
    },
    {
      question:
        '<h3>Why do users need to check the current train running status frequently on the date of the journey?</h3>',
      answer:
        '<p>Users may need to <strong>check live train status</strong> frequently on the journey date, like for boarding, deboarding, changing trains between stations, checking halt timing, distance yet to be covered, time required to reach destination, delays in schedule, or even arrival of loved ones.</p>'
    },
    {
      question: '<h3>How is delay or on-time information calculated for a running train?</h3>',
      answer:
        '<p>All trains in Indian Railways are installed with GPS devices, which provide data about train status. Data related to the train departure, arrival, and all in-between stations is collated to determine the timely or delayed arrival of your train.</p>'
    },
    {
      question: '<h3>What is ETA according to the Indian railway? How does MakeMyTrip calculate ETA?</h3>',
      answer:
        '<p>ETA refers to the Estimated Time of Arrival for trains under Indian Railways. MakeMyTrip uses data sourced from Indian Railways’s NTES to calculate ETA.</p>'
    },
    {
      question: '<h3>What could be the possible reasons for not getting the information on train running status?</h3>',
      answer:
        '<p>You may not be able to access <strong>live train status</strong> for various reasons, like lack of GPS connectivity for your train, slow internet connectivity on your device, etc.</p>'
    }
  ]
};

export const LTS_LANDING_META_DATA = {
  template_name: 'lts-landing',
  title: 'IRCTC Live Train Running Status | Live Train Enquiry - MakeMyTrip',
  description:
    'Check Train Running Status by just adding Train No. & get your Trains details through Live Running Train Status of IRCTC Train. Get Real Time Information about Your Train so that you can reach station according to current train running status.',
  keywords:
    'live train status, track train, spot your train, current train status, Indian railway train status, Train status, running train status',
  h1Title: 'Check Live Train Status'
};

export const LTS_LANDING_INSTRUMENTATION_PAGE_NAME = 'mob:funnel:ris:lts:ltslanding';

export const FOOTER_DATA = {
  'Product Offering': {
    links: [
      {
        text: 'Flights',
        onClickUrl: 'https://www.makemytrip.com/flights/',
        id: 'flights'
      },
      {
        text: 'International Flights',
        onClickUrl: 'https://www.makemytrip.com/international-flights/',
        id: 'international-flights'
      },
      {
        text: 'Charter Flights',
        onClickUrl: 'https://www.makemytrip.com/charter-flights/',
        id: 'charter-flights'
      },
      {
        text: 'Hotels',
        onClickUrl: 'https://www.makemytrip.com/hotels/',
        id: 'hotels'
      },
      {
        text: 'International Hotels',
        onClickUrl: 'https://www.makemytrip.com/hotels-international/',
        id: 'international-hotels'
      },
      {
        text: 'Homestays and Villas',
        onClickUrl: 'https://www.makemytrip.com/homestays/',
        id: 'homestays-and-villas'
      },
      {
        text: 'Activities',
        onClickUrl: 'https://www.makemytrip.com/activities/',
        id: 'activities'
      },
      {
        text: 'Holidays In India',
        onClickUrl: 'https://www.makemytrip.com/holidays-india',
        id: 'holidays-in-india'
      },
      {
        text: 'International Holidays',
        onClickUrl: 'https://www.makemytrip.com/holidays-international',
        id: 'international-holidays'
      },
      {
        text: 'Book Hotels From UAE',
        onClickUrl: 'https://www.makemytrip.com/hotels/?ccde=ae',
        id: 'book-hotels-from-uae'
      },
      {
        text: 'myBiz for Corporate Travel',
        onClickUrl: 'https://mybiz.makemytrip.com/?intid=mmtfooter_productoffering',
        id: 'mybiz-for-corporate-travel'
      },
      {
        text: 'Book Online Cabs',
        onClickUrl: 'https://www.makemytrip.com/cabs',
        id: 'cabs'
      },
      {
        text: 'Book Bus Tickets',
        onClickUrl: 'https://www.makemytrip.com/bus-tickets/',
        id: 'bus-tickets'
      },
      {
        text: 'Book Train Tickets',
        onClickUrl: 'https://www.makemytrip.com/railways/',
        id: 'train-tickets'
      },
      {
        text: 'Cheap Tickets to India',
        onClickUrl: 'https://www.makemytrip.com/?ccde=us',
        id: 'cheap-tickets-to-india'
      },
      {
        text: 'Book Flights From US',
        onClickUrl: 'https://www.makemytrip.com/flights/?ccde=us',
        id: 'book-flights-from-us'
      },
      {
        text: 'Book Flights From UAE',
        onClickUrl: 'https://www.makemytrip.com/flights/?ccde=us',
        id: 'book-flights-from-uae'
      },
      {
        text: 'Trip Planner',
        onClickUrl: 'https://planner.makemytrip.com/?&intid=Homepage_Tab_Inspirock',
        id: 'trip-planner'
      },
      {
        text: 'Gift Cards',
        onClickUrl: 'https://www.makemytrip.com/gift-cards',
        id: 'gift-vouchers'
      },
      {
        text: 'Trip Money',
        onClickUrl: 'https://www.tripmoney.com/',
        id: 'trip-money'
      },
      {
        text: 'Trip Ideas',
        onClickUrl: 'https://www.makemytrip.com/tripideas/',
        id: 'trip-ideas'
      },
      {
        text: 'Travel Blog',
        onClickUrl: 'https://www.makemytrip.com/blog/?intid=mmtblog_footer',
        id: 'travel-blog'
      },
      {
        text: 'PNR Status',
        onClickUrl: 'https://www.makemytrip.com/railways/PNR/',
        id: 'pnr-status'
      }
    ]
  },
  MakeMyTrip: {
    links: [
      {
        text: 'About Us',
        onClickUrl: 'https://www.makemytrip.com/about-us/company_profile.php',
        id: 'about-us'
      },
      {
        text: 'Investor Relations',
        onClickUrl: 'https://investors.makemytrip.com',
        id: 'investor-relations'
      },
      {
        text: 'Careers',
        onClickUrl: 'https://www.makemytrip.com/about-us/jobs.php',
        id: 'careers'
      },
      {
        text: 'MMT Foundation',
        onClickUrl: 'https://www.makemytrip.com/csr/mmt_foundation.html',
        id: 'mmt-foundation'
      },
      {
        text: 'CSR Policy',
        onClickUrl: 'https://www.makemytrip.com/csr/csr_policy.html',
        id: 'csr-policy'
      },
      {
        text: 'myPartner - Travel Agent Portal',
        onClickUrl: 'https://mypartner.makemytrip.com',
        id: 'mypartner---travel-agent-portal'
      },
      {
        text: 'Foreign Exchange',
        onClickUrl: 'https://www.fxkart.com/makemytrip?utm_source=MMTAFF',
        id: 'foreign-exchange'
      },
      {
        text: 'List your hotel',
        onClickUrl: 'https://www.makemytrip.com/hotels/hotelier-register.htm',
        id: 'list-your-hotel'
      },
      {
        text: 'Partners- Redbus',
        onClickUrl: 'https://www.redbus.com/',
        id: 'redbus'
      },
      {
        text: 'Partners- Goibibo',
        onClickUrl: 'https://www.goibibo.com/',
        id: 'goibibo'
      },
      {
        text: 'redRail Train Ticket Booking,',
        onClickUrl: 'https://www.redbus.in/train-tickets',
        id: 'redRail-ticket'
      },
      {
        text: 'redRail PNR Status',
        onClickUrl: 'https://www.redbus.in/railways/pnrstatus',
        id: 'redRail-pnr'
      },
      {
        text: 'redBus Bus Ticket Booking',
        onClickUrl: 'https://www.redbus.in/',
        id: 'redBus-bus-booking'
      }
    ]
  },
  'About the Site': {
    links: [
      {
        text: 'Customer Support',
        onClickUrl: 'https://supportz.makemytrip.com/Mima/CustomerHelpAndSupport/',
        id: 'customer-support'
      },
      {
        text: 'Payment Security',
        onClickUrl: 'https://www.makemytrip.com/legal/payment_security.html',
        id: 'payment-security'
      },
      {
        text: 'Privacy Policy',
        onClickUrl: '`https://www.makemytrip.com/legal${urlParam}/privacy_policy.html`',
        id: 'privacy-policy'
      },
      {
        text: 'User Agreement',
        onClickUrl: '`https://www.makemytrip.com/legal${urlParam}/user_agreement.html`',
        id: 'user-agreement'
      },
      {
        text: 'Terms of Service',
        onClickUrl: '`https://www.makemytrip.com/legal${urlParam}/user_agreement.html#tos`',
        id: 'terms-of-service'
      },
      {
        text: 'More Offices',
        onClickUrl: 'https://www.makemytrip.com/support/branch-offices.php',
        id: 'more-offices'
      },
      {
        text: 'Make A Payment',
        onClickUrl: 'https://payments.makemytrip.com/easypay/',
        id: 'make-a-payment'
      },
      {
        text: 'Work From Home',
        onClickUrl: 'https://www.makemytrip.com/about-us/work-from-home.php',
        id: 'work-from-home'
      }
    ]
  },
  'Important Links': {
    links: [
      {
        text: 'Bangalore to Mysore Trains',
        onClickUrl: 'https://www.makemytrip.com/railways/bangalore-mysore-train-tickets.html',
        id: 'blr-mys'
      },
      {
        text: 'Mumbai to Goa Trains',
        onClickUrl: 'https://www.makemytrip.com/railways/mumbai-goa-train-tickets.html',
        id: 'mum-goa'
      },
      {
        text: 'Pune to Mumbai Trains',
        onClickUrl: 'https://www.makemytrip.com/railways/pune-mumbai-train-tickets.html',
        id: 'pun-mum'
      },
      {
        text: 'Delhi to Jaipur Trains',
        onClickUrl: 'https://www.makemytrip.com/railways/delhi-jaipur-train-tickets.html',
        id: 'del-jai'
      },
      {
        text: 'Hyderabad to Tirupati Trains',
        onClickUrl: 'https://www.makemytrip.com/railways/hyderabad-tirupati-train-tickets.html',
        id: 'hyd-tir'
      },
      {
        text: 'Delhi to Agra Trains',
        onClickUrl: 'https://www.makemytrip.com/railways/delhi-agra-train-tickets.html',
        id: 'del-agr'
      },
      {
        text: 'Bangalore to Goa Trains',
        onClickUrl: 'https://www.makemytrip.com/railways/bangalore-goa-train-tickets.html',
        id: 'blr-goa'
      },
      {
        text: 'Bangalore to Chennai Trains',
        onClickUrl: 'https://www.makemytrip.com/railways/bangalore-chennai-train-tickets.html',
        id: 'blr-che'
      },
      {
        text: 'Mumbai  to Ahmedabad Trains',
        onClickUrl: 'https://www.makemytrip.com/railways/mumbai-ahmedabad-train-tickets.html',
        id: 'mum-ahm'
      },
      {
        text: 'Mumbai  to Delhi Trains',
        onClickUrl: 'https://www.makemytrip.com/railways/mumbai-delhi-train-tickets.html',
        id: 'mum-del'
      },
      {
        text: 'Pune to Goa Trains',
        onClickUrl: 'https://www.makemytrip.com/railways/pune-goa-train-tickets.html',
        id: 'pun-goa'
      },
      {
        text: 'Hyderabad to Bangalore Trains',
        onClickUrl: 'https://www.makemytrip.com/railways/hyderabad-bangalore-train-tickets.html',
        id: 'hyd-blr'
      },
      {
        text: 'Delhi to Amritsar Trains',
        onClickUrl: 'https://www.makemytrip.com/railways/delhi-amritsar-train-tickets.html',
        id: 'del-amr'
      },
      {
        text: 'Jaipur To Goa Trains',
        onClickUrl: 'https://www.makemytrip.com/railways/jaipur-goa-train-tickets.html',
        id: 'jai-goa'
      },
      {
        text: 'Kolkata To Goa Trains',
        onClickUrl: 'https://www.makemytrip.com/railways/kolkata-goa-train-tickets.html',
        id: 'kol-goa'
      },
      {
        text: 'Lakhimpur To Lucknow Train',
        onClickUrl: 'https://www.makemytrip.com/railways/lakhimpur-lucknow-train-tickets.html',
        id: 'lak-luc'
      }
    ]
  },
  'Quick Links': {
    links: [
      {
        text: 'IRCTC Train Ticket',
        onClickUrl: 'https://www.makemytrip.com/railways',
        id: 'irctc'
      },
      {
        text: 'Southern Railway',
        onClickUrl: 'https://www.makemytrip.com/railways/southern-railways-trains.html',
        id: 'sou-rail'
      },
      {
        text: 'Western Railway',
        onClickUrl: 'https://www.makemytrip.com/railways/western-railways-trains.html',
        id: 'wes-rail'
      },
      {
        text: 'IRCTC Seat Availability',
        onClickUrl: 'https://www.makemytrip.com/railways/trains-seat-availability-status.html',
        id: 'irctc-seat'
      },
      {
        text: 'Railway Time Table',
        onClickUrl: 'https://www.makemytrip.com/railways/railways-time-table.html',
        id: 'rail-tt'
      },
      {
        text: 'Indian Railway Stations',
        onClickUrl: 'https://www.makemytrip.com/railways/list-of-indian-railway-stations.html',
        id: 'ind-rail'
      },
      {
        text: 'Taktal Reservation',
        onClickUrl: 'https://www.makemytrip.com/railways/tatkal-tickets-booking.html',
        id: 'tat-res'
      },
      {
        text: 'Garib Rath',
        onClickUrl: 'https://www.makemytrip.com/railways/garib-rath-exp-12203-train.html',
        id: 'garib-rath'
      },
      {
        text: 'Shatabdi Express',
        onClickUrl: 'https://www.makemytrip.com/railways/shatabdi-exp-12008-train.html',
        id: 'sha-exp'
      },
      {
        text: 'Duronto Express',
        onClickUrl: 'https://www.makemytrip.com/railways/duronto-express-12246-train.html',
        id: 'dur-exp'
      },
      {
        text: 'Rajdhani Express',
        onClickUrl: 'https://www.makemytrip.com/railways/rajdhani-exp-12431-train.html',
        id: 'raj-exp'
      },
      {
        text: 'Goibibo PNR Status',
        onClickUrl: 'https://www.goibibo.com/trains/check-pnr-status/',
        id: 'gi-pnr'
      },
      {
        text: 'Live Train Status',
        onClickUrl: 'https://www.makemytrip.com/railways/liveStatus/',
        id: 'lts'
      },
      {
        text: 'Gomti Express',
        onClickUrl: 'https://www.makemytrip.com/railways/new-delhi-lucknow-nr-gomti-express-12420-train.html',
        id: 'gom-exp'
      },
      {
        text: 'Shalimar Express',
        onClickUrl: 'https://www.makemytrip.com/railways/delhi-jammu-tawi-shalimar-exp-14645-train.html',
        id: 'shm-exp'
      },
      {
        text: 'Vande Bharat Express',
        onClickUrl: 'https://www.makemytrip.com/railways/varanasi-jn-new-delhi-vande-bharat-exp-22435-train.html',
        id: 'van-exp'
      },
      {
        text: 'Gatimaan Express',
        onClickUrl: 'https://www.makemytrip.com/railways/h-nizamuddin-jhansi-jn-gatimaan-exp-12050-train.html',
        id: 'gat-exp'
      },
      {
        text: 'Gitanjali Express',
        onClickUrl: 'https://www.makemytrip.com/railways/howrah-jn-c-shivaji-mah-t-gitanjali-exp-12860-train.html',
        id: 'git-exp'
      },
      {
        text: 'Sabari Express',
        onClickUrl: 'https://www.makemytrip.com/railways/hyderabad-decan-trivandrum-cntl-sabari-exp-17230-train.html',
        id: 'sab-exp'
      },
      {
        text: 'Avadh Express',
        onClickUrl: 'https://www.makemytrip.com/railways/gorakhpur-jn-bandra-terminus-avadh-express-19038-train.html',
        id: 'ava-exp'
      },
      {
        text: 'Vivek Express',
        onClickUrl: 'https://www.makemytrip.com/railways/dibrugarh-kanyakumari-vivek-express-15906-train.html',
        id: 'viv-exp'
      },
      {
        text: 'Tejas Express',
        onClickUrl: 'https://www.makemytrip.com/railways/c-shivaji-mah-t-karmali-tejas-express-22119-train.html',
        id: 'tej-exp'
      },
      {
        text: 'Intercity Express',
        onClickUrl: 'https://www.makemytrip.com/railways/pune-jn-c-shivaji-mah-t-intercity-exp-12128-train.html',
        id: 'int-exp'
      },
      {
        text: 'Tapti Ganga Express',
        onClickUrl: 'https://www.makemytrip.com/railways/chhapra-surat-tapti-ganga-exp-19046-train.html',
        id: 'TG-exp'
      }
    ]
  }
};

export const CANONICAL_URL = {
  landingPage: 'https://www.makemytrip.com/railways/liveStatus/',
  trainNumberPage: 'https://www.makemytrip.com/railways/train-number/',
  datePickerPage: 'https://www.makemytrip.com/railways/date-picker/',
  stationPickerPage: 'https://www.makemytrip.com/railways/station-picker/'
};

export const FAQ_CONTENT_SCHEMA_URL = {
  faqPage: 'http://schema.org/FAQPage',
  question: 'http://schema.org/Question',
  answer: 'http://schema.org/Answer'
};
